// removed by extract-text-webpack-plugin
module.exports = {"CustomCluster":"CustomMarkerCluster__CustomCluster__2yfx8","Beer":"CustomMarkerCluster__Beer__STK7s","Bike":"CustomMarkerCluster__Bike__I8-Fm"};


//////////////////
// WEBPACK FOOTER
// ./src/Hoc/CustomMarkerCluster/CustomMarkerCluster.css
// module id = 261
// module chunks = 0